import axiosInstance from "@/utils/axiosInstance";
import { clearCache, wrapFetchValue } from "./storeCache";

const baseUrl = `api/notifications`;

const state = {
  headerNotifications: [],
  unreadCount: 0,
};

const getters = {
  headerNotifications: (state) => state.headerNotifications,
  unreadCount: (state) => state.unreadCount,
};

const mutations = {
  SET_HEADER_NOTIFICATIONS(state, notifications) {
    state.headerNotifications = notifications;
  },

  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = count;
  },

};

const actions = {
  markAsRead({ dispatch, state }, notificationId) {
    return axiosInstance
      .put(`${baseUrl}/${notificationId}/read`)
      .then(() => clearCache(state, "NOTIFS"));
  },

  delete({ dispatch, state }, notificationId) {
    return axiosInstance
      .delete(`${baseUrl}/${notificationId}`)
      .then(() => clearCache(state, "NOTIFS"));
  },
  create({ commit }, payload) {
    return axiosInstance.post(`${baseUrl}/${payload.notificationType}`, payload)
      .then((data) => data.data);
  },
  /*
   * Permet de mettre à jour les infos du Badge et Dropdown Notification
   * @param param
   * @returns
   */
   async refetchNotifications({ commit, dispatch, rootGetters }) {
    const user = rootGetters.currentUser;
    if (!user || !user.id) { return; }

    const userId = user.id;

    return await wrapFetchValue( state, "NOTIFS", () => {
      return dispatch(
        "users/getUserNotifications",
        {
          userId,
          pagination: {
            page: 1,
            itemsPerPage: 3,
            unread: true,
          },
        },
        { root: true },
      ).then(async (notifications) => {
        commit("SET_HEADER_NOTIFICATIONS", notifications.rows);
        commit("SET_UNREAD_COUNT", notifications.count);
      });
    },
    { expiredIn: 1 });
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
